<template>
  <div 
    :class="{ 
      'info-warp': true, 
      'top-border': showTopBorder, 
      'bottom-border': showBottomBorder 
    }"
  > 
    <a-row class="info-title" type="flex" justify="space-between" align="bottom">
      <div class="title-name">{{ title }}</div>
      <div class="number">
        <span v-if="count" style="padding-left:10px">
          <count-to 
            :startVal='beforeCount' 
            :endVal='count' 
            :duration='3000'
          /> {{$t('dashboard.personnelUnit')}}
        </span>
      </div>
    </a-row>
    <div class="info-content-warp">
      <slot></slot>
    </div>    
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { numberFomartToSample } from '@/utils/utils'

export default {
  name: 'InfoWarp',
  components: { countTo },
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    showTopBorder: {
      type: Boolean,
      default: true
    },
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      beforeCount: 0
    }
  },
  watch: {
    count: function(newVal, oldVal) {
      this.beforeCount = oldVal
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
  .info-warp{
    background-color: rgba(0,0,0,0.2);
    height: 100%;
    position: relative;
    padding: 10px 20px;

    .info-title{
      padding-top: 10px;
      font-weight: bold;

      .title-name{
        padding: 0 10px;
        font-size: 15px;
        position: relative;
      }
      .title-name:before,.title-name:after{
        content: '';
        width: 2px;
        height: 14px;
        background-color: #ffb400;
        position: absolute;
        top: 4px;
      }
      .title-name:before{
        left: -1px;
      }
      .title-name:after{
        right: -1px;
      }

      .number {
        color: #00fffc;
        // width: calc(100% - 82px);
        width: calc(100% - 180px);
        white-space: nowrap;
        display: table;
      }
      .number:before{
        content: '';
        width:100%;
        border-bottom: 2px solid rgba(0,112,255,0.3);
        position: relative;
        display: table-cell;
        bottom: 4px;
      }
    }
  }
  .top-border:before,.bottom-border:after{
    content: '';
    width: 100%;
    height: 40px;
    background-image: url('../../../assets/dashboard/border.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    
    left: 0;
  }
  .top-border:before{
    top: -20px;
  }
  .bottom-border:after{
    bottom: -20px;
  }

  .info-content-warp{
    height: calc(100% - 32px);
  }
</style>
